const getIsFree = ({ currentCurrencyOfferByPeriod }) =>
  currentCurrencyOfferByPeriod.offer_amount === 0;

export default getIsFree;
